import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import translationEN from "../../src/languageChange/translationEN.json";
import translationDE from "../../src/languageChange/translationDE.json";
import translationTM from "../../src/languageChange/translationTM.json";
import translationHI from "../../src/languageChange/translationHI.json";
import translationFR from "../../src/languageChange/translationFR.json";
import translationSP from "../../src/languageChange/translationSP.json";
import translationPO from "../../src/languageChange/translationPO.json";
import translationRU from "../../src/languageChange/translationRU.json";
import translationCH from "../../src/languageChange/translationCH.json";

const resources = {
  en: {
    translation: translationEN,
  },
  ar: {
    translation: translationDE,
  },
  ta: {
    translation: translationTM,
  },
  hi: {
    translation: translationHI,
  },
  fr: {
    translation: translationFR,
  },
  sp: {
    translation: translationSP,
  },
  po: {
    translation: translationPO,
  },
  ru: {
    translation: translationRU,
  },
  ch: {
    translation: translationCH,
  },
};

i18n
  .use(Backend)

  .use(LanguageDetector)

  .use(initReactI18next)

  .init({
    resources,
    fallbackLng: "en",
    debug: true,
    lng: "en",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
